import React, { useEffect, useRef, useState } from "react";
import { Tooltip, Modal, Select } from 'antd';
import styles from "./filelistcenter.module.scss";
//import { StatusTag } from "../../../../shared/widgets/statusTag";
import { URInput } from "../../../../shared/widgets/input";
import { URButton } from "../../../../shared/widgets/button";
import ListView from "../contactFiles/listView";
import GridView from "../contactFiles/GridView";
import { contacts, contactwindowDetails, LoginState ,
  chatwindowDetails,
  rightSidePanelDetails,
  initialStateModel} from "../../../../models/model";
import store from "../../../../context/store/store";
import { downloadAttachment, getcontactDetail,
  pptFormats,excelFormats, wordFormats, zipFormats,
   pdfFormats, imageFormat, videoFormat ,
  SearchFilter,  getFileSize, Cookie, mp3Formats } from "../../../../base/utils";
import iconpdf from "../../../../styles/images/grid_pdf.svg";
import iconppt from "../../../../styles/images/grid_ppt.svg";
import iconword from "../../../../styles/images/grid_word.svg";
import iconxls from "../../../../styles/images/grid_xls.svg";
import iconzip from "../../../../styles/images/grid_zip.svg";
import moment from "moment";
import FilePreview from "../../../chat/chatWidgets/filePreview";
import { ChatService } from "../../../../base/chatService";
import { useHistory } from "react-router-dom";
import _ from "lodash";
import AllFilePreview from "../../../chat/chatWidgets/allFilePreview";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../../../styles/images/chat blank state loading.json";
import ContactLoader from "../../../../styles/images/Lottie Animation.json";
import NoContent from "../../../../shared/widgets/noContent";
import FileNoFound from "../../../../styles/images/empty_states/files_empty_state.svg";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import { toastInformation, userStatusColor } from "../../../../base/callService/common";
import { SocketChatService } from "../../../../base/socketChatService";
import { generateChatID, userInfo } from "../../../../base/socketChatService/utils";
import { useSelector } from "react-redux";
import { config } from "../../../../base/constant";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { Types } from "../../../../context/action/action";
import iconmusic from "../../../../styles/images/grid_music.svg";
type filecenterState={
Activetab:boolean;
fileList:any;
allFilesList:any;
offset:number;
limit:number;
selectedId:any;
fileGirdViewdata:any
isOpen:boolean;
isDelete:boolean;
isShare:boolean;
contactList: Array<any>;
searchContactList: Array<any>;
selectedmember: Array<any>;
contactDetail:Array<any>;
shareingFile:any;
deletingFile:any;
isSearch:boolean;
isallFiles:boolean;
fileGirdViewalldata:any;
searchWord:string;
fileDescription:string;
}
export default function FileListCenter() {
  const history = useHistory();
  let {contactFileList }:contactwindowDetails = useSelector((state:initialStateModel)=>state.contactWindowReducer);
  let {allContacs} :contacts = store.getState().contactReducer;
  const [filecenterDataLoading, setfilecenterDataLoading] = useState<filecenterState>({
    Activetab:true,fileList:[],offset:0,limit:10,selectedId:'',allFilesList:contactFileList,fileGirdViewdata:{},
    isOpen:false,isDelete:false,
    selectedmember: [],shareingFile:{},fileGirdViewalldata:{},
    contactList: allContacs, searchContactList: allContacs,contactDetail:[],
    deletingFile:{},isSearch:false,
    isShare:false,isallFiles:false, searchWord:"",fileDescription:""});
  const [shareFileInfo, setshareFileInfo] = useState<any>();
  
  const {isMySpace}:chatwindowDetails = useSelector((state : initialStateModel)=> state.chatWindowReducer);
  // const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
  const socketChat = useRef<any>(null);
  useEffect(()=>{
    const userInfo:any =Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if(userInfosess){
      const cookieData =JSON.parse(userInfosess);
      socketChat.current= new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
  },[])
 
  // const menu = (
  //   <Menu className="rightdropactions">
  //     <Menu.Item className="active"><span className="icon_tick"></span><b>All</b></Menu.Item>
  //     <Menu.Item><span className="icon_tick"></span><b>Sort by: Due date</b></Menu.Item>
  //     <Menu.Item><span className="icon_tick"></span><b>
  //       <StatusTag className='statusCompleted' name='Completed' /></b></Menu.Item>
  //     <Menu.Item><span className="icon_tick"></span>
  //       <b><StatusTag className='statusunderinProgress' name='In Progress' /></b></Menu.Item>
  //     <Menu.Item><span className="icon_tick"></span>
  //       <b><StatusTag className='statusunderReview' name='In Review' /></b></Menu.Item>
  //     <Menu.Item><span className="icon_tick"></span>
  //       <b><StatusTag className='statusHold' name='On hold' /></b></Menu.Item>
  //   </Menu>
  // );


  const allFilePreviewer=()=>{
    setfilecenterDataLoading({...filecenterDataLoading,isallFiles:!filecenterDataLoading.isallFiles});
  };
  const onclickallfilegetId=(id:any)=>{
    setfilecenterDataLoading({...filecenterDataLoading,fileGirdViewalldata:id,

      isallFiles:!filecenterDataLoading.isallFiles
    });
  };


  // const handleCancelall = () => {
  //   setfilecenterDataLoading({...filecenterDataLoading,isallFiles:false});
  // };
  let { contactWindowDetails,isfileLoad,
    isContactFile
  }:contactwindowDetails = store.getState().contactWindowReducer;
  let {ischatfileLoad}:rightSidePanelDetails=store.getState().chatRightSidePanelReducer;

  useEffect(() => {


    if (isMySpace && window.location.pathname === "/chats") {
      let savedListMyspace = {
        offset: 100, orderType: 0, id: ""
      };
      socketChat?.current?.getmySpaceFileList(savedListMyspace);

    }else{

      let id = contactWindowDetails?.chatId ? contactWindowDetails?.chatId :
      contactWindowDetails?.team_id;
      
      let filelist ={
        chatId:id,
        offset : 100,
        orderType : 1,
        id : ""
      }
      socketChat?.current?.fileListData(filelist);
    }

  
  },[contactWindowDetails]);
  const FilePreviewer = ()=>{
    setfilecenterDataLoading({...filecenterDataLoading,isOpen:!filecenterDataLoading.isOpen});
  };
  const onclickgetId=(id:any)=>{
    setfilecenterDataLoading({...filecenterDataLoading,fileGirdViewdata:id,isOpen:!filecenterDataLoading.isOpen});    
  };


  // const getFilebyId=()=>{
  //   let data = contactWindowDetails?contactWindowDetails : "";
  //   if(isMySpace && window.location.pathname=== "/chats"){
  //   }
  //   else
  //   {
  //     let id = "";
  //     if ('team_id' in data)
  //     {
  //       id = data.team_id_prefix + data.team_id;

  //     } else
  //     {
  //       id = data.sip_login_id.toString();

  //     }
  //   }
  // };

  // const handleScroll = (e: any) =>
  // {
  //   const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
    
  //   if(isMySpace && window.location.pathname=== "/chats"){
      
  //     if(bottom && isfileStopPagination){

       
  //       // ChatService.filesPagination(loggedUser.sip_login_id,filecenterDataLoading.limit+10,
  //       //   filecenterDataLoading.offset);
  //     }
  //   }
  //   else{
      
  //     if(bottom && isfileStopPagination){
       
       
  //       let data = contactWindowDetails?contactWindowDetails : "";
  
  //       let id = "";
  //       if ('team_id' in data)
  //       {
          
  //         id = data.team_id_prefix + data.team_id;
    
  //       } else
  //       {
  //         id = data.sip_login_id.toString();
    
  //       }
  

  //       /* let filelist ={
  //         chatId:id,
  //         offset : 25,
  //         orderType : 1,
  //         id : contactFileList[contactFileList.length -1]?.id
  //       }

     
  //       socketChat.fileListData(filelist); */
  //       // contactService.filesPagination(id,filecenterDataLoading.limit+10,filecenterDataLoading.offset);
  //       setfilecenterDataLoading({...filecenterDataLoading,
  //         limit: filecenterDataLoading.limit + 10,
  //         offset: filecenterDataLoading.offset});
        
  //     }
  //   }
   
  // };
  
  // const groupbyday = (response: any) =>
  // {
  //   const uniqueFilesList = Array.from(new Set(response.map((a:any) => a.msgId)))
  //     .map(msgId => {
  //       return response.find((a:any) => a.msgId === msgId);
  //     });
  //   let data: any = uniqueFilesList ? uniqueFilesList : [];
  //   const groups =
  //     data &&
  //     data.reduce((groups: any, game: any) =>
  //     {
  //       let date: any = get_recent_date(game.timeStamp);

  //       date = date.split(" ");
  //       date = date[4];
  //       if (!groups[date])
  //       {
  //         groups[date] = [];
  //       }
  //       groups[date].push(game);
  //       return groups;
  //     }, {});
  //   console.log(groups,"groupsgroups");
  //   const groupArrays = Object.keys(groups).map((date) =>
  //   {
  //     return {
  //       date,
  //       messageArray: groups[date]
  //     };
  //   });
  //   console.log(groupArrays,"groupArrays");
  //   setfilecenterDataLoading({...filecenterDataLoading,fileGirdView:groupArrays});
  //  // this.setState({ fileGirdView: groupArrays });
  // };
 

  const downloadAlfilesfromAttach = (filedata:any) =>
  {
    downloadAttachment(filedata);
  };
 
  const closeSelection =()=>{
    let deletedArray:any=[];
 
  
    store.dispatch({
      type: Types.GET_FILES_LIST,
      payload: {
        selectMessageData:deletedArray
      }
    });
 
    setfilecenterDataLoading({...filecenterDataLoading,isDelete:false});
  };
  const handleCancelforShare=()=>{
    setfilecenterDataLoading({...filecenterDataLoading,isShare:false,contactDetail :[],selectedmember:[],fileDescription:""});
  };
  const onChangeSelectMembers =(e:any)=>{
    
    let {userdetails}:LoginState = store.getState().loginReducer;
    let contact:any=
    e.map((item:string)=>
    {
      return getcontactDetail(item.toString(),filecenterDataLoading.contactList,userdetails);
    });
    
    
    
   
    setfilecenterDataLoading({
      ...filecenterDataLoading, selectedmember: e,
      searchContactList: filecenterDataLoading.contactList,contactDetail:contact
    });
   
  };
  const onSearchMembers = (value: any) => {
    let response = SearchFilter(filecenterDataLoading.contactList, value.toLowerCase());
    setfilecenterDataLoading({ ...filecenterDataLoading, searchContactList: response });

  };
  const shareFile =()=>{
    if (filecenterDataLoading.selectedmember.length < 1 ) return toastInformation("No contacts selected", "warning");
    if(!(_.isUndefined(filecenterDataLoading.shareingFile))){
    let contactFileListArray : any= [];
    contactFileListArray.push(filecenterDataLoading.shareingFile);
    ChatService.forwardMessage(contactFileListArray,filecenterDataLoading.contactDetail )
    setfilecenterDataLoading({...filecenterDataLoading,isShare:false,contactDetail :[],selectedmember:[],shareingFile:{},fileDescription:""});
    toastInformation('File shared successfully', 'success')
    }
  };
  const openShare=(file:any)=>{
    let messageBody= file?.message?.body
    messageBody["text"] = "";
    setshareFileInfo({messageBody});

    setfilecenterDataLoading({...filecenterDataLoading,isShare:true,shareingFile:file});
  };

  const openDelete=(file:any)=>{
    setfilecenterDataLoading({...filecenterDataLoading,isDelete:true,deletingFile:file});
  };
  const downloadfiles =(files:any)=>{
    downloadAlfilesfromAttach(files);
    toastInformation('Success! File downloaded', 'success')
  };
  const deleteContactFile =()=>{
if(!(_.isUndefined(filecenterDataLoading.deletingFile))){
  socketChat.current.deleteForEveryone(filecenterDataLoading.deletingFile.id);
  setfilecenterDataLoading({...filecenterDataLoading,isDelete:false});
  let deletedFile =_.findIndex(contactFileList,((ele:any,index:any)=>{
    if(index!==-1)
    {return ele.id === filecenterDataLoading.deletingFile.id; }
  }));
  contactFileList.splice(deletedFile,1)  
  store.dispatch({
    type: Types.CONTACT_FILES_LIST,
    payload: {
      isContactFile:true,
      contactFileList:contactFileList
  }});
  filecenterDataLoading.deletingFile?.message?.messageType === "IMAGE" ? toastInformation(config().IMAGEDELETED, 'success') :
  filecenterDataLoading.deletingFile?.message?.messageType === "FILE" ? toastInformation(config().FILEDELETED, 'success') :
  toastInformation(config().FILEDELETED, 'success');
}
  };

  const viewinConversation =(fileData:any)=>{
    history.push({pathname:"/chats", search: `id=${fileData.id}`
    });
    let contact = fileData?.type === 1? fileData?.to : "con"+fileData?.chatId;
    let contactsDetail = getcontactDetail(contact);
    let chatDetail ={chatId:generateChatID(userInfo().fromID,contactsDetail?.sip_login_id?contactsDetail?.sip_login_id.toString() :contactsDetail?.team_id.toString())};
    var  chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
    ChatService.openChatWindow(contactsDetail,history,chatDetail);
    let dataRes:any = {chatId:fileData?.chatId,"id":fileData.id }
    chatService.Savehistory(dataRes);
    setTimeout(()=>{
      ChatService.saveChatHighlight(true,fileData);
    }, 500)
  };

  const searchFile=(e:any)=>{
    let searchText=e.target.value.toLowerCase();
    let contactFileListsearch=  contactFileList;
    let response:any =   _.filter(contactFileListsearch, function(data:any) {
      let searchFileData= data?.message?.body
      let fileName = searchFileData.fileName || "";
      let Datesearch = moment(new Date(parseInt(data.sourceTimestamp))).format("ddd, MMM DD YYYY") || '';
      return (((fileName).toLowerCase()).includes(searchText)
      ||(Datesearch).toLowerCase().includes(searchText));
    });
    setfilecenterDataLoading({...filecenterDataLoading,isSearch:true,allFilesList:response,searchWord:searchText});
  };
  let len = Math.ceil((filecenterDataLoading?.searchContactList?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

  return (
    <>
      <div className={styles.taskmain} >
        <div className={styles.rightbartop}>
          <div className={styles.tasksearchbar}>
            <div className={styles.lefts}>
              <ul>
                <li><Tooltip mouseEnterDelay={0.5}  placement="top" title={'Grid View'}>
                  <label className={filecenterDataLoading.Activetab ?`icon_Keypadfill ${styles.active}`:
                    "icon_Keypadfill"}
                  onClick={()=>setfilecenterDataLoading({...filecenterDataLoading,
                    Activetab: true })}></label></Tooltip></li>
                    
                  <li><Tooltip mouseEnterDelay={0.5}  placement="top" title={'List View'}>
                  <label className={!filecenterDataLoading.Activetab ?`icon_listview ${styles.active}`:
                  "icon_listview"}
                    onClick={()=>setfilecenterDataLoading({...filecenterDataLoading,
                      Activetab:false})}></label></Tooltip></li>               
              </ul>
            </div>
            <div className={styles.rights}>
              <URInput placeHolder="Search" className={`customFocused ${styles.rightbarsearch}`} onChange={searchFile} />
            </div>
          </div>
          
        </div>
        {isContactFile===true && contactFileList.length === 0 && <NoContent image={FileNoFound}
          title={"Worktual files"}
          description={<>No files.</>} /> }
        <div className={`${'scroller'} ${styles.rightbarbottom}`} >

          
          {!filecenterDataLoading.Activetab &&
          <ListView fileslist={filecenterDataLoading.allFilesList}
            searchWord={filecenterDataLoading.searchWord}
            isSearch={filecenterDataLoading.isSearch}
            onclickgetId={onclickgetId}
            onclickallfilegetId={onclickallfilegetId}
            openShare={openShare}
            openDelete={openDelete}
            downloadfiles={downloadfiles}
            viewinConversation={viewinConversation}
          />}
          {filecenterDataLoading.Activetab &&
          <GridView
            isSearch={filecenterDataLoading.isSearch}
            searchWord={filecenterDataLoading.searchWord}
            fileslist={filecenterDataLoading.allFilesList}
            onclickgetId={onclickgetId}
            onclickallfilegetId={onclickallfilegetId}
            openShare={openShare}
            openDelete={openDelete}
            downloadfiles={downloadfiles}
            viewinConversation={viewinConversation}
          />}
          { isfileLoad && <Lottie className="svgLoading"
            animationData={ContactLoader} />}
          { ischatfileLoad && <Lottie className="svgLoading"
            animationData={ContactLoader} />}
        </div>
      </div>
      {filecenterDataLoading.isOpen
      && <FilePreview isOpen={filecenterDataLoading.isOpen}
        data={filecenterDataLoading.fileGirdViewdata}
        groupdata={contactFileList}
        previewopen={FilePreviewer} />}

      {filecenterDataLoading.isallFiles
     
      && <AllFilePreview isOpen={filecenterDataLoading.isallFiles}
        data={filecenterDataLoading.fileGirdViewalldata}
        groupdata={contactFileList}
        previewopen={allFilePreviewer} />}
         
    {filecenterDataLoading.isDelete &&  <Modal title="Delete file"
        centered
        visible={filecenterDataLoading.isDelete}
        onOk={deleteContactFile}
        onCancel={closeSelection}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        Are you sure you want to permanently delete the selected file?
      </Modal>}

     {filecenterDataLoading.isShare && <Modal visible={filecenterDataLoading.isShare} className={`${styles.addmembermodal} ${"modaloverwrite"}`}>
        <div className={styles.drop}>
          <span className={`icon_close ${styles.cursorTop}`} onClick={handleCancelforShare}/>
          <h2>Share this file</h2>
          <div className={styles.insideicon}>
            {/* <img src={taskimg2} alt="" /> */}
            <Select
              mode="multiple"
              onChange={(e: any) => onChangeSelectMembers(e)}
              onSearch={onSearchMembers}
              style={{ width: '100%' }}
              filterOption={false}
              showSearch={true}
              value={filecenterDataLoading.selectedmember}
              placeholder="Search Name / Group/ Extension"
              className="createNewSel"
              dropdownClassName="newChatSel">
              { filecenterDataLoading?.searchContactList?.map((contact:any,index:any)=>{
               
                let name= contact?.caller_id ?contact?.caller_id : contact?.team_name;
                return(
             
                  <option key={index}
                    value={contact.sip_login_id?contact.sip_login_id: `con${contact.team_id}`}>
                    <div className="dropdowndesign">
                      <div className="usergroupss">
                        {/* {contact.ImageURL || contact.profile_image_url?
                          <img src={contact.ImageURL?contact.ImageURL:contact.profile_image_url}/>:
                          <span>{name?.charAt(0)}</span>
                        }
                        <URStatusDot className={userStatusColor(contact?.user_status,'small')}/>
                         */}
                         <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`} profileInfo={<>
                        {contact.ImageURL || contact.profile_image_url?
                          <><img alt="" src={(contact.ImageURL)?contact.ImageURL:contact.profile_image_url}/>
                            <URStatusDot
                              className={userStatusColor(contact?.user_status,'small')}/></>:
                          <span>{name?.charAt(0).toUpperCase()}<URStatusDot
                            className={userStatusColor(contact?.user_status,'small')}/></span>
                        }
                      </> } />
                      </div>
                      <div className="names">{name && name}</div>
                      {!contact.team_id && <div className="ext">{contact?.ext}</div>}
                    </div>
                  </option>
              
                );

            
              })  }
         
            </Select>
            {/* <div className={styles.insideicon}>
           <TextArea rows={3} name="fileDescription" title="Add a message, if you'd like." value={filecenterDataLoading?.fileDescription} placeholder="Add a message, if you'd like."
              onChange={(e)=>addFileDescription(e)} className="notesArea"/>
          </div> */}
          </div>
          <div className={`${styles.sharePpfileCont} ${styles.lftImfseccont}`}>
            {shareFileInfo&&
            imageFormat.indexOf(shareFileInfo?.messageBody?.fileType)!== -1  ?
              <img src={shareFileInfo?.messageBody?.filePath} alt=""/>:
              excelFormats.indexOf(shareFileInfo?.messageBody?.fileType) !== -1 ?
                <img  src={iconxls} alt="" />:
                pptFormats.indexOf(shareFileInfo?.messageBody?.fileType)!== -1  ?
                  <img  src={iconppt} alt="" />:
                    pdfFormats.indexOf(shareFileInfo?.messageBody?.fileType)!== -1  ?
                      <img  src={iconpdf} alt="" />:
                      wordFormats.indexOf(shareFileInfo?.messageBody?.fileType)!== -1  ?
                        <img  src={iconword} alt="" />:
                        zipFormats.indexOf(shareFileInfo?.messageBody?.fileType)!== -1  ?
                          <img  src={iconzip} alt="" />:
                          mp3Formats.indexOf(shareFileInfo?.messageBody?.fileType)  !== -1 ?
                          <img className={styles.filelistimage} src={iconmusic} alt=""
                            /> :
                          videoFormat.indexOf(shareFileInfo?.messageBody?.fileType) !== -1  ?
                          <div className="videoFiles">
                          <video className="videoFluid" controls={true} preload="metadata">
                            <source src={shareFileInfo?.messageBody?.filePath} type="video/mp4" />
                          </video>
                          <div className="videoPlay"></div>
                        </div>
                          :
                            <img  src={iconpdf} alt="" />
            }
            <p className={styles.shareFileNamepopup}><span>{shareFileInfo?.messageBody?.fileName}</span>
              <span>File size:{getFileSize(shareFileInfo?.messageBody?.filesize)}</span></p>
          </div>
          <div className={styles.footersection}>
            <URButton className={styles.cancelbtn} onClick={handleCancelforShare} name="Cancel"></URButton>
            <URButton className={styles.savebtn} onClick={shareFile} name="Share"></URButton>
          </div>
        </div>
      </Modal> }
     
    </>
  );
};

